<template>
  <div>
    <accounts v-if="storeAccounts" :btnText="'다음'" @emitResult="callback"></accounts>
  </div>
</template>

<script>
import Accounts from '@/components/account/Accounts.vue'
import { mapActions, mapState } from 'vuex'
export default {
  components: {
    Accounts,
  },
  computed: {
    ...mapState('account', {
      storeAccounts: 'accounts',
    }),
  },
  async created() {
    _meta({
      titles: ['매출 계정 연동'],
    })
  },
  methods: {
    ...mapActions('auth', ['getMe']),
    async callback(result) {
      if (result === true) {
        await this.getMe()
        this.$router.push(`/signup/step2`)
      }
    },
  },
}
</script>

<style></style>
